/* global WufooForm */

import {analyticsClient} from '../../../analytics-client';

type DefaultValues = {
    firstName: string | null | undefined;
    lastName: string | null | undefined;
    companyName: string | null | undefined;
    emailAddress: string | null | undefined;
};

function translateDefaultValuesToFields(defaultValues: DefaultValues) {
    const defaults: Record<string, any> = {};
    if (defaultValues.firstName) {
        defaults.field1 = defaultValues.firstName;
    }

    if (defaultValues.lastName) {
        defaults.field2 = defaultValues.lastName;
    }

    if (defaultValues.emailAddress) {
        defaults.field3 = defaultValues.emailAddress;
    }

    if (defaultValues.companyName) {
        defaults.field6 = defaultValues.companyName;
    }

    return new URLSearchParams(defaults);
}

export function mountAnalyticsHelpForm(defaultValues: DefaultValues) {
    analyticsClient.track(analyticsClient.EVENTS.TRACK_ANALYTICS_GET_HELP_FORM_VIEWED);

    const defaultFieldValues = translateDefaultValuesToFields(defaultValues);

    (function (d, t) {
        const s = d.createElement(t),
            options = {
                userName: 'nutshellcrm',
                formHash: 'r143emax0qa3rg2',
                autoResize: true,
                height: '500',
                async: true,
                host: 'wufoo.com',
                header: 'show',
                ssl: true,
                defaultValues: defaultFieldValues,
            } as const;
        // @ts-expect-error
        s.src = `${
            'https:' === d.location.protocol ? 'https://' : 'http://'
        }www.wufoo.com/scripts/embed/form.js`;
        // @ts-expect-error
        s.onload = s.onreadystatechange = function () {
            // @ts-expect-error
            const rs = this.readyState;
            if (rs) if (rs !== 'complete') if (rs !== 'loaded') return;
            try {
                // @ts-expect-error
                const wufooForm = new WufooForm();
                wufooForm.initialize(options);
                wufooForm.display();
            } catch (_e: any) {
                // Ignoring error
            }
        };
        const scr = d.getElementsByTagName(t)[0],
            // @ts-expect-error
            par = scr.parentNode;
        if (par) {
            // @ts-expect-error
            par.insertBefore(s, scr);
        }
    })(document, 'script');
}
